function SvgComponent(props: any) {
  return (
    <svg
      width={164}
      height={96}
      viewBox="0 0 164 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.137 86.5a9.5 9.5 0 01-9.5 9.5h-30a9.5 9.5 0 010-19h.24a9.778 9.778 0 01-5-8.535c0-5.402 4.379-9.78 9.78-9.78h-34.52c-5.402 0-9.78-4.38-9.78-9.781 0-5.402 4.378-9.781 9.78-9.781h37.964c-5.398-.005-9.772-4.382-9.772-9.781 0-5.402 4.379-9.78 9.78-9.78H26.782c-5.402 0-9.78-4.38-9.78-9.782C17 4.38 21.378 0 26.78 0h78.247c5.401 0 9.78 4.379 9.78 9.78 0 5.402-4.379 9.781-9.78 9.781h27.616c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.78-9.781 9.78h-13.799c5.397.005 9.772 4.383 9.772 9.782 0 5.401-4.379 9.78-9.781 9.78h34.52c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.781-9.781 9.781h-52.012a9.497 9.497 0 014.793 8.254z"
        fill="#EDFFF5"
      />
      <circle cx={134} cy={6} r={2} fill="#27AE60" />
      <circle cx={43} cy={73} r={2} fill="#27AE60" />
      <path
        d="M151.703 47.854l-.203-.281-.203.28-2.165 3-.286.397h5.308l-.286-.396-2.165-3zM3.717 12.875L3.5 12.5l-.217.375-2.165 3.75L.902 17h5.196l-.216-.375-2.165-3.75z"
        stroke="#27AE60"
        strokeWidth={0.5}
      />
      <path
        d="M80 28a5 5 0 00-5 5v13.017a13.698 13.698 0 012.5-.462V33a2.5 2.5 0 012.5-2.5h10v8.75A3.75 3.75 0 0093.75 43h8.75v20a2.5 2.5 0 01-2.5 2.5h-9a13.768 13.768 0 01-1.642 2.5H100a5.002 5.002 0 005-5V41.535a3.753 3.753 0 00-1.1-2.65l-9.785-9.787A3.75 3.75 0 0091.465 28H80zm21.983 12.5H93.75a1.25 1.25 0 01-1.25-1.25v-8.233l9.483 9.483zM90 59.25a11.25 11.25 0 11-22.5 0 11.25 11.25 0 0122.5 0zm-5.365-4.635a1.25 1.25 0 00-1.77 0l-6.615 6.617-1.615-1.617a1.252 1.252 0 00-1.77 1.77l2.5 2.5a1.25 1.25 0 001.77 0l7.5-7.5a1.25 1.25 0 000-1.77z"
        fill="#27AE60"
      />
    </svg>
  )
}

export default SvgComponent
